/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const NotificationPreference = zod.object({
  emailEnabled: zod
    .boolean()
    .describe('Whether notification emails for this topic are delivered to the user'),
  inAppEnabled: zod
    .boolean()
    .describe('Whether this topic appears in the in-app notification feed (the bell)'),
  mandatoryChannels: zod
    .array(
      zod
        .enum(['in_app', 'push', 'email', 'sms'])
        .describe('Delivery channel for a notification topic'),
    )
    .describe(
      'Channels this topic ALWAYS uses regardless of the stored preference, because some notification of this kind is transactional (an invitation you must receive to accept). Render these as locked-on, not as a toggle: writing false here is accepted and stored, but delivery ignores it.',
    ),
  mandatoryReasons: zod
    .record(zod.string(), zod.string())
    .describe(
      'Per-channel explanation for a locked toggle, keyed by channel. Show it next to the lock so \"always on\" reads as a reason rather than as a bug.',
    ),
  pushEnabled: zod.boolean().describe('Whether pushes for this topic are delivered to the user'),
  smsEnabled: zod
    .boolean()
    .describe('Whether notification SMS for this topic are delivered to the user'),
  supportedChannels: zod
    .array(
      zod
        .enum(['in_app', 'push', 'email', 'sms'])
        .describe('Delivery channel for a notification topic'),
    )
    .describe(
      'Channels the client may expose toggles for on this topic. Unsupported channels stay disabled and cannot be enabled.',
    ),
  topic: zod
    .enum([
      'content-shares',
      'group-invites',
      'booking-task-updates',
      'payment-receipts',
      'chat-invitations',
      'thread-messages',
    ])
    .describe(
      'Notification category: content shares, group invitations, booking & task updates, payment receipts, or chat invitations',
    ),
});

export type NotificationPreference = zod.input<typeof NotificationPreference>;
export type NotificationPreferenceOutput = zod.output<typeof NotificationPreference>;
